import axios from '../utils/axios';
import { ApiResponseBody } from '../types/subscription';
import { ClaimResult, GiftsPayload } from '../types/gifts';

const unwrapBody = <T,>(response: { data: ApiResponseBody<T> }) => response.data.body;

export const giftsApi = {
    getGifts: async () => unwrapBody<GiftsPayload>(await axios.get('/api/gifts')),
    claimGift: async (itemId: string) => unwrapBody<ClaimResult>(await axios.post('/api/claim-gift', { item_id: itemId })),
};

/** `image_path` is relative to the API origin; REACT_APP_API_URL already ends at /api. */
export const giftImageUrl = (path: string | null): string | null =>
    path ? `${(process.env.REACT_APP_API_URL || '/api').replace(/\/+$/, '')}/${path}` : null;
